exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.submit-wrap[data-v-02854f71] {\n  padding: 0 5%;\n}\n", "", {"version":3,"sources":["/root/workspace/ClassKitSite_lZoD/src/components/el-submit-button.vue"],"names":[],"mappings":";AAwDA;EACE,cAAc;CACf","file":"el-submit-button.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.submit-wrap {\n  padding: 0 5%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02854f71","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/el-submit-button.vue
// module id = onrs
// module chunks = 165